import namespace from "@rdfjs/namespace";
const builder = namespace("http://www.loc.gov/mads/rdf/v1#");
export const strict = builder;
export const loose = builder;
